import clsx from 'clsx';
import { CSSProperties, ReactElement, useMemo } from 'react';

import { RGBAColor, hexToRgb, rgbToString } from '@vestico/utils';

import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import style from './blurredBackgroundText.module.css';

export interface BlurredBackgroundTextProps {
  corner?: 'left' | 'right';
  color?: string;
  children: ReactElement | ReactElement[];
}
export const BlurredBackgroundText = ({ corner, color, children }: BlurredBackgroundTextProps) => {
  const backgroundCSS = useMemo(() => {
    if (!color) {
      return undefined;
    }
    const rgbValue = hexToRgb(color);
    const rgbaValue: RGBAColor = { ...rgbValue, alpha: 0.8 };

    const css: CSSProperties = { backgroundColor: `rgba(${rgbToString(rgbaValue)})` };
    return css;
  }, [color]);

  return (
    <div>
      <div
        className={clsx(style.background, { [style.corner]: !!corner }, { [style.left]: corner === 'left' }, { [style.right]: corner === 'right' })}
        style={backgroundCSS}
      >
        <div className={clsx(style.text, globalStyle.textSmall, globalStyle.textBold)}>{children}</div>
      </div>
    </div>
  );
};
